import { createSlice } from "@reduxjs/toolkit";
const initialPersonState = { personData: {} };

export const personSlice = createSlice({
  name: "person",
  initialState: initialPersonState,
  reducers: {
    setPersonState(state, action) {
      state.personData = { ...state.personData, ...action.payload };
    },
    resetPersonState(state) {
     // state.personData = {};
     return initialPersonState;
    },
    updatePersonState(state, action) {
      state.personData = { ...state.personData, ...action.payload };
    },
  },
});
